import { Box, Flex, Heading, Text, Skeleton } from '@chakra-ui/react';
import { useLocation } from 'wouter';
import { useRecipes } from '@/lib/recipeService';
import { ROUTES } from '@/types';
import RecipeCard from './RecipeCard';

export default function HomeRecentRail() {
  const [, navigate] = useLocation();

  const { recipes, isLoading } = useRecipes({ sort: 'recent', limit: 6 });

  return (
    <Box data-testid="home-recent-rail">
      <Flex justify="space-between" align="baseline" px={4} pb={3}>
        <Heading fontFamily="heading" fontWeight="800" fontSize="15px" color="text.primary" letterSpacing="-0.2px">
          Recently added <Text as="span" color="accent.secondary">·</Text>
        </Heading>
        <Text
          fontFamily="body"
          fontWeight="600"
          fontSize="12px"
          color="accent.secondary"
          cursor="pointer"
          onClick={() => navigate(ROUTES.RECIPES_BASE())}
        >
          See all
        </Text>
      </Flex>

      <Box
        display={{ base: 'flex', lg: 'grid' }}
        flexDirection="column"
        gridTemplateColumns={{ lg: 'repeat(2, minmax(0, 480px))' }}
        gap={2}
        px={4}
        pb={4}
      >
        {isLoading
          ? Array.from({ length: 4 }).map((_, i) => (
              <Skeleton key={i} data-testid="recipe-skeleton" borderRadius="12px" h="80px" />
            ))
          : recipes.map((recipe) => (
              <RecipeCard
                key={recipe.id}
                recipe={recipe}
                onRecipeClick={(id) => navigate(ROUTES.RECIPE(id))}
              />
            ))
        }
      </Box>
    </Box>
  );
}
